import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs';
import Rails from "@rails/ujs"
import { hideSavingDisplay, showSavingDisplay } from "../components/saving_display"

export default class extends Controller {
  connect() {
    const sortable = Sortable.create(this.element, {
      ghostClass: 'question-block_dragged',
      onEnd: (evt) => {
        const itemForm = evt.item.querySelector("form");
        const formSelect = itemForm.querySelector("select");
        const previousOptionSelected = formSelect.querySelector("option[selected=selected]");
        const newOptionSelected = formSelect.querySelector(`option[value="${evt.newDraggableIndex + 1}"]`);

        // Show saving display
        showSavingDisplay();

        // Update order display
        let i = 1;
        for (const child of evt.to.children) {
          const orderSpan = child.querySelector(`span[data-ordered="true"]`);
          orderSpan.innerHTML = `${i}`
          i += 1;
        }

        // Save new order
        previousOptionSelected.removeAttribute("selected");
        newOptionSelected.setAttribute("selected","selected");
        Rails.fire(itemForm, "submit");
        itemForm.addEventListener('ajax:success', () => {
          hideSavingDisplay()
        });
        itemForm.addEventListener('ajax:error', () => {
          hideSavingDisplay()
        });
      },
    });
  }
}
